import { render, staticRenderFns } from "./ViewCampaigns.vue?vue&type=template&id=ed4982fe&scoped=true"
import script from "./ViewCampaigns.vue?vue&type=script&lang=js"
export * from "./ViewCampaigns.vue?vue&type=script&lang=js"
import style0 from "./ViewCampaigns.vue?vue&type=style&index=0&id=ed4982fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4982fe",
  null
  
)

export default component.exports